<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Antrian Per Poli Detail
                </h1>
            </div>
            <div class="w-full mx-auto grid grid-cols-2 gap-4">
                <Link :href="`/admin/antrian/${layanan.FS_KD_LAYANAN}`" class="btn-menu  bg-red-500 hover:bg-red-600 w-full text-center" v-for="layanan in layanan"> 
                    {{ layanan.FS_NM_LAYANAN }}
                </Link>
            </div>
            
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
export default {
    components: {
        Link,
        RandomShape
    },
    props: {
        layanan: Object,
    },
    layout: LayoutAdmin
};
</script>
